module.exports = __webpack_public_path__ + "static/media/explore-4a.86df09c3.jpeg";